import { useEffect, useMemo, useState } from 'react'
import { ParallaxProvider } from 'react-scroll-parallax'
import { BrowserRouter, Route } from 'reactima-router'
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-react'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import dayjs from 'dayjs'
import { createBrowserHistory } from 'history'
import GsapPage from './pages/gsap/gsap'
import InReactimaPage from './pages/in/reactima'
import IndexPage from './pages/index'
import NotesPage from './pages/notes/notes'
import TrendingPage from './pages/trending/trending'

import { findByKey, ProConfigContext } from '@/locale/intl'

dayjs.locale('en')

// const FARO = false
// if (FARO) {
//   initializeFaro({
//     // Mandatory, the URL of the Grafana collector
//     // url: 'https://reactima.com/collect',
//     url: 'https://reactima.com/collect',
//     apiKey: 'FQWELFKQae3WELFKWELF2141413224',
//
//     // Mandatory, the identification label of your application
//     app: {
//       name: 'reactima.local',
//     },
//
//     instrumentations: [
//       // Load the default Web instrumentations
//       ...getWebInstrumentations(),
//       // Tracing Instrumentation is needed if you want to use the React Profiler
//       new TracingInstrumentation(),
//     ],
//   })
// }

const history = createBrowserHistory()

function App() {
  const [pageLoaded, setPageLoaded] = useState(false)

  useEffect(() => {
    setPageLoaded(true)
  }, [])

  useEffect(() => {
    const redirectServerPath = window.location.hash.includes('#/') ? window.location.hash.replace('#/', '/') : ''
    if (redirectServerPath) {
      history.push(redirectServerPath)
    }
  }, [])

  return (
    <ParallaxProvider>
      {pageLoaded ? (
        <ParallaxProvider>
          <BrowserRouter history={history}>
            <Route exact path="/notes" component={NotesPage} />
            <Route exact path="/trending" component={TrendingPage} />
            <Route exact path="/gsap" component={GsapPage} />
            <Route exact path="/in/reactima" component={InReactimaPage} />

            <Route exact path="/" component={IndexPage} />
          </BrowserRouter>
        </ParallaxProvider>
      ) : null}
    </ParallaxProvider>
  )
}

export default App
